import React, { useState, useContext, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import StoreDetailHeader from './StoreDetailHeader'
import RefContainerList1 from '../ui/RefContainerList1'
import RefContainerList2 from '../ui/RefContainerList2'
import { getDeepCopy, useFormHandler } from '../../utils/Custom'
import StoreContext from '../../context/store/StoreContext'
import { PencilIcon, PlusIcon } from '../../img/images'
import Drawer from '../input/Drawer'
import { CardContainer, ListContainer } from '../layout/Containers'
import { Spinner } from '../layout/Spinner'
import { withComponentLabel } from '../../utils/debug'
// import { useHistory, redirect } from 'react-router-dom'

const StoreDetailPage = () => {
  const storeContext = useContext(StoreContext)
  const { storeId } = useParams()

  const { currentStore, setCurrentStore, getStore } = storeContext

  useEffect(() => {
    // call getStore with storeId and set currentStore to that
    const callGetStore = async () => {
      const store = await getStore(storeId)
      setCurrentStore(store)
    }
    callGetStore()
    setLoading(false)
    // eslint-disable-next-line
  }, [])

  const [loading, setLoading] = useState(true)

  return (
    <>
      <ListContainer>
        <CardContainer>
          {/* if loading return spinner, otherwise return StoreDetailPageContent but only if there is a currentStore */}
          {loading ? (
            <Spinner />
          ) : (
            currentStore && (
              <StoreDetailPageContent currentStore={currentStore} />
            )
          )}
        </CardContainer>
      </ListContainer>
    </>
  )
}

// need to pass currentStore so that it will have a passed reference to 'stores' and will update that reference on submit
const StoreDetailPageContent = (props) => {
  // const history = useHistory()
  const navigate = useNavigate()

  const { currentStore } = props
  const storeContext = useContext(StoreContext)

  const { clearCurrentStore, updateStore, deleteStore } = storeContext

  // this stores the changes to-be-saved while the user is editing
  // this is what gets passed on submit
  const [thisStore, setThisStore] = useState({
    ...currentStore,
    name: currentStore.name,
    locations: currentStore.locations,
    items: currentStore.items, // all stores that current item is in
  })

  // this is what gets edited from the modal
  // necessary for checkbox management and UI updating
  const [thisStoreShadow, setThisStoreShadow] = useState({
    ...currentStore,
    name: currentStore.name,
    locations: getDeepCopy(currentStore.locations),
    items: getDeepCopy(currentStore.items),
  })

  const [showDrawer, setShowDrawer] = useState(false)

  const [changeVal, submitVal, state] = useFormHandler(updateStore, {
    name: '',
  })

  const unorganizedItems = thisStore.items.filter(
    (item) => item.locations.length === 0
  )

  // ==================== ACTIONS ====================

  const locationDelete = (location) => {
    // remove location from main location storage
    const locations = thisStoreShadow.locations.filter(
      (loc) => loc.name !== location.name
    )
    // remove location from items which have it in their item.locations
    const items = thisStoreShadow.items.map((item) => {
      item.locations = item.locations.filter(
        (loc) => loc.name !== location.name
      )
      return item
    })
    // keep these 2 in sync for the modal onChange otherwise shadow
    // will overwrite changes after the OK modal button clicked
    setThisStoreShadow((prevState) => ({ ...prevState, locations, items }))
    setThisStore((prevState) => ({ ...prevState, locations, items }))
  }

  // informs what items to render under a location + what boxes should
  // already be checked in the edit modal (listRef and comparisonArr)
  const getItemsInLocation = (store, location) => {
    return store.items.filter((item) =>
      item.locations
        .map((loc) => loc.name)
        .flat()
        .includes(location.name)
    )
  }

  // ==================== HANDLERS ====================

  const onAddButtonClick = () => {
    setShowDrawer(!showDrawer)
  }

  const onDeleteStoreClick = async () => {
    await deleteStore(currentStore) // wait for delete to finish so store is not in list when it redirects
    clearCurrentStore()
    // bring the user back to the stores page without letting them navigate back to the deleted store
    // history.replace('/stores')
    // history.goBack()
    navigate(-1)
  }

  const onChangeLocation = (e) => {
    e.preventDefault()
    changeVal({ name: e.target.value })
  }

  const modalOkLocations = (e) => {
    e.preventDefault()
    setThisStore((prevState) => ({
      ...prevState,
      locations: [...prevState['locations'], state],
    }))
    submitVal({ ...thisStore, locations: [...thisStore['locations'], state] })
    changeVal({ name: '' })
  }

  // ==================== BUTTONS ====================

  const editIcon = (
    <PencilIcon
      color="fill-gray-600"
      height="9"
      width="9"
    />
  )
  const addIcon = (
    <PlusIcon
      color="fill-gray-700"
      height="9"
      width="9"
    />
  )

  const addButton = (
    <Drawer
      addIcon={addIcon}
      handleButtonClick={onAddButtonClick}
      display={showDrawer}
      action={modalOkLocations}
      onChange={onChangeLocation}
      placeholder="Enter location name..."
    />
  )

  return (
    <>
      <StoreDetailHeader
        deleteClick={onDeleteStoreClick}
        store={thisStore}
        changeAction={() => console.log('change action')}
      />
      <RefContainerList2
        listRef={thisStore.locations}
        headerText="Locations"
        editButton={editIcon}
        insertButton={addButton}
        secondaryContentAction={locationDelete}
      />
      {thisStore.locations.map((location, i) => {
        const locationItems = getItemsInLocation(thisStore, location)
        return (
          <RefContainerList1
            key={i}
            listRef={locationItems}
            headerText={location.name}
          />
        )
      })}
      {unorganizedItems.length > 0 && (
        <RefContainerList1
          listRef={unorganizedItems}
          headerText="Unorganized"
          editButton={''}
        />
      )}
    </>
  )
}

export default withComponentLabel(StoreDetailPage, 'StoreDetailPage')